<template>
    <div class="messaging">
        <div class="messages">
            <div v-for="msg in filteredMessages" :key="msg.id" class="message">
                <strong>{{ getFirstName(msg.sender) }}:</strong> {{ msg.text }}
                <span class="timestamp">{{ formatTimestamp(msg.timestamp) }}</span>
            </div>
        </div>
        <form @submit.prevent="sendMessage">
            <input
                v-model="newMessage"
                type="text"
                placeholder="Type your message..."
                required
            />
            <button type="submit">Send</button>
        </form>
    </div>
</template>
<script>
export default {
    name: "Messaging",
    props: {
        activeAccountId: {
            type: String,
            required: true,
        },
        currentUser: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            users: [
                { username: "Alice", firstName: "Alice" },
                { username: "Bob", firstName: "Bob" },
                // Add more users as needed
            ],
            messages: [
                // Example message structure:
                // { id: 1, accountId: 'abc', sender: 'Alice', text: 'Hello!', timestamp: 1718000000000 }
            ],
            newMessage: "",
        };
    },
    computed: {
        filteredMessages() {
            return this.messages.filter(
                (msg) => msg.accountId === this.activeAccountId
            );
        },
    },
    methods: {
        sendMessage() {
            if (!this.newMessage.trim()) return;
            this.messages.push({
                id: Date.now(),
                accountId: this.activeAccountId,
                sender: this.currentUser,
                text: this.newMessage,
                timestamp: Date.now(),
            });
            this.newMessage = "";
            this.$nextTick(() => {
                const container = this.$el.querySelector(".messages");
                if (container) container.scrollTop = container.scrollHeight;
            });
        },
        formatTimestamp(ts) {
            const date = new Date(ts);
            return date.toLocaleTimeString();
        },
        getFirstName(username) {
            const user = this.users.find(u => u.username === username);
            return user ? user.firstName : username;
        },
    },
};
</script>

<style scoped>
.messaging {
    background: #fafafa;
}
.messages {
    max-height: 300px;
    overflow-y: auto;
    margin-bottom: 12px;
    padding-right: 8px;
}
.message {
    margin-bottom: 8px;
}
.timestamp {
    color: #888;
    font-size: 0.8em;
    margin-left: 8px;
}
form {
    display: flex;
    gap: 8px;
}
input[type="text"] {
    flex: 1;
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #bbb;
}
button {
    padding: 6px 16px;
    border-radius: 4px;
    border: none;
    background: #1976d2;
    color: #fff;
    cursor: pointer;
}
button:hover {
    background: #1565c0;
}
</style>